/**
 * Created by DejanK on 3/13/2017.
 */
import Server from './server'

export default MainServer

MainServer.$inject = ['$http'];
function MainServer($http){ return Server($http, '/api/') }
